import { render } from "./form-text-editor.vue?vue&type=template&id=70f3152e"
import script from "./form-text-editor.vue?vue&type=script&lang=js"
export * from "./form-text-editor.vue?vue&type=script&lang=js"

import "./form-text-editor.vue?vue&type=style&index=0&id=70f3152e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__